import { Typography, Box } from "@mui/material";
import React, { useState, useEffect, memo } from "react";

import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import { getUser } from "../../Model/LocalStorage";
import { auctionsLive, auctionsLiveDeclarator } from "../../Model/Auction";
import GridLayout from "./gridLayout";
import Page from "../../../components/Page";
import NoEvent from "./NoEvent";
import LayoutHeaderAuctions from "../header/Appbar";
import MessageIcon from "@mui/icons-material/Message";
import { hostname } from "../../../config";
import Chat from "./chat";
import "./chat.css";
import useMediaQuery from "@mui/material/useMediaQuery";

const socket = hostname;
// const socket = io.connect("http://localhost:3005");

function View(props) {

  const [status, setStatus] = React.useState(0);
  const matchesPhone = useMediaQuery("(min-width:700px)");
  const [loading, setLoading] = React.useState(false);
  const [message, setMessage] = useState("");
  const [getData, setGetData] = useState([]);
  const [room, setRoom] = useState("");
  const [group, setGroup] = useState("");
  const [type, setType] = useState("");
  const [username, setUsername] = useState("");
  const LiveAuction = (group) => {
    
    setLoading(true);
    try {
      async function getAuctionOne() {
          let results;
        if(group === "ADMIN"){
          results = await auctionsLiveDeclarator();
       }else{
        results = await auctionsLive();
       }
      //   // const results = await auctionsLive();
    
        if (results.success === false) {
          setMessage(results.msg);
          setOnline(!isOnline);
        } else {
          // alert(results.auction_details.isLive)
          setStatus(results.auction_details.isLive)
          setGetData(results);
          setRoom(results.auction_details.auction_id);
          console.log(results.auction_details.auction_id)
          socket.emit("joint_room", results.auction_details.auction_id);
        }
        // setGetData(results);
        setLoading(false);
      }
      getAuctionOne().catch(console.error);
    } catch (error) {}

    fetch(`http://157.230.43.47:3005/type`, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    })
      .then((response) => response.json())
      .then((data) => {
        // alert(data.isDesktop)
        setType(data.isMobile);
      })
      .catch((error) => {
        console.log("error ", error);
      });
  };

  const [isOnline, setOnline] = useState(true);
  const updateNetworkStatus = () => {
    setOnline(navigator.onLine);
    // setMessage("Network Error!...");
  };

  useEffect(() => {
    //  return () =>  socket.removeAllListeners();
      window.addEventListener("load", updateNetworkStatus);
      window.addEventListener("online", updateNetworkStatus);
      window.addEventListener("offline", updateNetworkStatus);

    return () => {
      window.removeEventListener("load", updateNetworkStatus);
      window.removeEventListener("online", updateNetworkStatus);
      window.removeEventListener("offline", updateNetworkStatus);
      // window.addEventListener("click",onDisconnect)
    };
  }, [navigator.onLine, socket]);

  const [userID, setUserID] = useState("");
  useEffect(() => {
    try {
      // console.log("socket   ",socket.connected)
      // LiveAuction();
    async function getUserList() {
      const getuser = await getUser();

      LiveAuction(getuser === null ? "BIDDER":getuser.group);
 
      setUserID(getuser.id);
      setGroup(getuser.group);
      setUsername(getuser.email);
      socket.emit("ConnectedUser", {
        userId: getuser.id,
        email: getuser.email,
      });
    }

    // console.log("socket.connected : ",socket.connected)
    getUserList().catch(console.error);
  } catch (error) {
    // console.log("socket error   ",socket)
  }
    // if (socket.connected) {
    //   console.log('connect');
    //    socket.connect();
    //  } else {
    //    console.log('disconnect');
    //    alert('Socket is disconnected.');
    //  }
    // function onDisconnect() {
    //   if (socket.connected) {
    //     console.log('connect');
    //      socket.connect();
    //    } else {
    //      console.log('disconnect');
    //      alert('Socket is disconnected.');
    //    }
    // }
  }, [hostname,socket]);

  // const [open, setOpen] = React.useState(true);
  // const handleClickOpen = () => {
  //   setOpen(true);
  // };

  // const handleClose = () => {
  //   setOpen(!open);
  // };

  return (
    <div >
      <Page title="Auctions Room" >
    
          
            <GridLayout
            
              LiveData={getData}
              Socket={socket}
              Type={type}
              mediadQuery={props.mediadQuery}
            />
        
      
      </Page>

      {/* <div
        style={{
          position: "fixed",
          bottom: matchesPhone === true ? 0 : 100,
          right: "0%",
          marginRight: "-275px",
          borderRadius: 5,
          cursor: "pointer",
          zIndex: "99999px",
          margin: matchesPhone === true ? 5 : 0,
        }}
        open={true}
        onClose={handleClose}
      >
        <div
          onClick={handleClose}
          style={{
            background: "rgb(24 118 210)",
            color: "white",
            width: 60,
            height: 60,
            borderRadius: 60,
            textAlign: "center",
            fontSize: 20,
            lineHeight: "55px",
            display: open === true ? "block" : "none",
            // padding:"px 3px 0 3px"
          }}
        >
 

          <MessageIcon style={{ fontSize: 35 }} />
        </div>
      </div>

      <div
        style={{
          zIndex: 99999,
          // position: "relative",
          bottom: matchesPhone === true ? 550 : 0,
          display: open === false ? "block" : "none",
        }}
      >
        <div
          style={{
            position: "fixed",
            bottom: matchesPhone === true ? 0 : 100,
            right: "5%",
            marginBottom: 10,
          }}
        >
          <Chat
            socket={socket}
            username={"deleonfsad@gmail.com"}
            room={22}
            handleClose={handleClose}
            sender={userID}
          />
        </div>
      </div> */}

      {/* <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={!isOnline}
      >
        <b style={{ fontSize: 20 }}> {message}...&nbsp;&nbsp;&nbsp;&nbsp; </b>
        <CircularProgress color="inherit" />
      </Backdrop> */}
    </div>
  );
}

export default View;
